import { React, useState, useEffect } from "react";
import "./Home.css";
import Info1 from "../../components/InfoBlocks/Inforblocks1/Info";
import Info2 from "../../components/InfoBlocks/Inforblocks2/Info";
import Info3 from "../../components/InfoBlocks/Inforblocks3/Info";
import Info4 from "../../components/InfoBlocks/Inforblocks4/Info";
import Info5 from "../../components/InfoBlocks/Inforblocks5/Info";
import flag from "../../images/flag.png";
import azadi from "../../images/home-page-azadi.png";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import { Autoplay, Navigation, EffectFade } from "swiper";
import "swiper/css/effect-fade";
import { getAllImages } from "../../services/Api";

const Home = () => {

  const [today, setToday] = useState(new Date().getDate());
  const [images, setImages] = useState();
  const getImages = async (uid) => {
    const data = await getAllImages(uid);
    setImages(data.data.data);
    console.log(images);
  };
  
  useEffect(() => {
    const data = JSON.parse(window.localStorage.getItem("user"));
    console.log(data);
    getImages(data?.uid);
  }, []);
  
  return (
    <div className="home-container">
      <div className="head-container">
        <div className="text head-child">
          <div className="text-head-heading">Azadi Ka Amrit Mahotsav 2023</div>
          <div className="text1">
          ‘Har Ghar Tiranga’ is a campaign under the aegis of Azadi Ka Amrit Mahotsav to encourage people to bring the Tiranga home and to hoist it to mark the 76th year of India’s independence. Our relationship with the flag has always been more formal and institutional than personal. Bringing the flag home collectively as a nation in the 76th year of independence thus becomes symbolic of not only an act of personal connection to the Tiranga but also an embodiment of our commitment to nation-building.
          </div>
          <div className="text2">
            This Mahotsav is dedicated to the people of India who have not only
            been instrumental in bringing India thus far in its evolutionary
            journey but also hold within them the power and potential to enable
            Prime Minister Narendra Modi's vision of activating India 2.0,
            fuelled by the spirit of Aatmanirbhar Bharat.
            The idea behind the initiative is to invoke the feeling of patriotism in the hearts of the people and to promote awareness about the Indian National Flag.
          </div>
          <div className="text3">
            The official journey of Azadi Ka Amrit Mahotsav commenced on 12th
            March 2021 which started a 75-week countdown to our 75th anniversary
            of independence and will end post a year on 15th August 2023.
            Following are the five themes of Azadi Ka Amrit Mahotsav.
          </div>
        </div>

        {images?.length ? (
          <div className="image head-child">
            <Swiper
              spaceBetween={30}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              navigation={true}
              modules={[Autoplay, Navigation]}
              className="mySwiper swiper-fixed-width-500"
            >
              {images.map((elem) => (
                <SwiperSlide
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  data-swiper-autoplay="2000"
                >
                  <img
                    className="slider-img"
                    src={`https://harghartiranga.iiita.ac.in/${elem.url}`}
                    alt=""
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="information">
      
        <Info1 />
        <Info2 />
        <Info3 />
       
       
      </div>
      <footer>
        Code of Conduct | All Rights Reserved | IIIT ALLAHABAD | ©2022
      </footer>
    </div>
  );
};

export default Home;
